/**
 * Convenience function for splitting an array every other item
 * @param  {array} arr array to split
 * @return {array}     2D array
 *                     - first is the evens (including 0)
 *                     - second is the odds (not including 0)
 */
export default function splitArray(arr) {
  return [
    arr.filter((item, idx) => 0 === idx % 2),
    arr.filter((item, idx) => 0 !== idx % 2),
  ];
}



// WEBPACK FOOTER //
// ./app/utils/array/splitArray.js